import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const CuentaContablePickerFormGroup = ({
  iDescripcionName,
  iName,
  iLabel,
  iError,
  iTouched,
  values,
  setValues
}) => {
  const onChange = React.useCallback(
    salida => {
      values[iName] = salida.value
      values[iDescripcionName] = salida.label
      setValues(values)
    },
    [values, setValues, iName, iDescripcionName]
  )

  const clickClear = React.useCallback(() => {
    values[iName] = ''
    values[iDescripcionName] = ''
    setValues(values)
  }, [values, setValues, iName, iDescripcionName])

  return (
    <>
      <Form.Group>
        <Form.Label text={iLabel} htmlFor={`input-${iDescripcionName}`} md={4} alignRightAt='md' />
        <Col md={8}>
          {values[iDescripcionName] ? (
            <ClearInputGroup
              id={`input-${iDescripcionName}`}
              iValue={values[iDescripcionName]}
              clickClear={clickClear}
            />
          ) : (
            <Select2CuentaContable
              id={`name-${iDescripcionName}`}
              onlyAnalitica
              onChange={onChange}
            />
          )}
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(CuentaContablePickerFormGroup)
